<template>
  <div id="root" :class="[newClass && 'newdiv102']">
    <div class="container" v-if="is_new === 2">
      <div class="title">录音信息收集协议</div>
      <div class="dec"></div>
      <div class="toptext">
        为提升嘀嗒出行产品安全能力，更好地处理嘀嗒出行平台的司乘纠纷，嘀嗒出行上线录音功能。本协议将向您说明嘀嗒出行平台收集使用录音信息的情况，请您务必认真阅读本协议，在确认充分了解后慎重决定是否同意本协议。您点击同意后，本协议生效，对您及嘀嗒出行平台均具有法律约束力。
      </div>

      <div class="section">
        <div class="section-title">
          一、个人信息，是指以电子或者其他方式记录的能够单独或者与其他信息结合识别自然人个人身份的各种信息，在本隐私政策中包括：姓名、昵称、手机号码、用户密码、身份证或其他身份证明、照片、面部识别特征、性别、年龄、职业信息、征信信息、是否有犯罪记录、是否有不良行为记录、车辆信息、驾驶证、行驶证、车辆监督卡、常用地址、通讯地址、紧急联系人、位置信息、行程信息、通话记录、录音、订单信息及交易状态、支付信息、提现记录、银行卡号、评价信息、日志信息、设备信息、IP地址；
        </div>
      </div>

      <div class="section">
        <div class="section-title">
          二、录音将通过嘀嗒出行App或其他具备录音功能的软件或硬件进行。车主或乘客任何一方同意，录音功能即可开启。如乘客使用的嘀嗒出行App版本未及时更新，无法对录音进行授权，则录音不开启。在“拼车”场景下，在获得车主及部分乘客用户同意后，录音将开启。
        </div>
      </div>

      <div class="section">
        <div class="section-title">三、录音起始时间</div>
        <div class="section-item">
          1、嘀嗒顺风车、嘀嗒出租车录音自车主或乘客任意一方开启录音功能时开始，至车主或乘客关闭录音功能时停止（具体以嘀嗒出行App车主端显示的录音状态为准）。
        </div>
        <div class="section-item">
          2、嘀嗒出行其他上线录音功能的服务的录音起始时间以嘀嗒出行平台另行告知为准。
        </div>
      </div>

      <div class="section">
        <div class="section-title">
          四、为保障用户的隐私，录音将实时上传至嘀嗒出行服务器，用户无法自行下载、调取或播放录音。
        </div>
      </div>

      <div class="section">
        <div class="section-title">
          五、录音信息将用于以下明确列明的使用场景：
        </div>
        <div class="section-subitem">
          ① 在征得乘客同意的情况下，作为平台处理用户纠纷的依据。
        </div>
        <div class="section-subitem">
          ② 为维护用户人身安全等重大合法权益，或情况紧急又很难得到用户同意的。
        </div>
        <div class="section-subitem">
          ③ 用于抽查检验用户是否存在违反平台用户规则的行为。
        </div>
        <div class="section-subitem">
          ④ 用于系统分析，设计、开发、应用保护用户安全的辅助工具或产品。
        </div>
      </div>

      <div class="section">
        <div class="section-title">
          六、嘀嗒出行平台将严格保护用户个人信息安全，除以下情况外，我们不会向其他人共享您的录音信息：
        </div>
        <div class="section-subitem">① 相关机关依据法定程序调取。</div>
        <div class="section-subitem">② 用户持法律文件依法调取。</div>
      </div>

      <div class="section">
        <div class="section-title">
          七、录音保存期限为7日。如遇差评、投诉、尚未处理完毕的纠纷等，平台将适当延长录音保存期限。
        </div>
      </div>

      <div class="section">
        <div class="section-title">
          八、用户使用的手机等硬件设备故障、网络状态不稳定、App版本过旧以及不可抗力等因素均可能导致录音失败，您对此表示理解，如遇此类问题，嘀嗒出行平台不需承担责任。
        </div>
      </div>

      <div class="section">
        <div class="section-title">
          九、嘀嗒出行平台将严格按照本协议约定收集使用用户录音信息。本协议对相关内容未作明确约定的，以嘀嗒出行平台《个人信息保护及隐私政策》约定为准。
        </div>
      </div>
    </div>
    <div class="container" v-if="is_new === 1">
      <div class="title">录音信息收集协议</div>
      <div class="dec"></div>
      <div class="toptext">
        为提升嘀嗒出行产品安全能力，更好地处理嘀嗒出行平台的司乘纠纷，嘀嗒出行上线录音功能。本协议将向您说明嘀嗒出行平台收集使用录音信息的情况，请您务必认真阅读本协议，在确认充分了解后慎重决定是否同意本协议。您点击同意后，本协议生效，对您及嘀嗒出行平台均具有法律约束力。
      </div>

      <div class="section">
        <div class="section-title">
          一、您同意本协议后，使用嘀嗒顺风车、嘀嗒出租车服务时，如您确认开启录音功能，嘀嗒出行将通过软件或硬件设备录音您后续全部行程中的车内环境声音信息（包括您及车上人员交谈或肢体动作产生的声音），且本次行程中不再做单独提示。受技术条件影响，嘀嗒出行平台各项服务在不同城市上线录音功能的时间不同，具体以嘀嗒出行平台显示的录音状态为准。在夜间和长途行程中，为提升司乘安全保障，在行程开启前车主需开启录音功能，否则车主将无法使用部分功能。
        </div>
      </div>

      <div class="section">
        <div class="section-title">
          二、录音将通过嘀嗒出行App或其他具备录音功能的软件或硬件进行。车主或乘客任何一方同意，录音功能即可开启。如乘客使用的嘀嗒出行App版本未及时更新，无法对录音进行授权，则录音不开启。在“拼车”等场景下，在获得车主及部分乘客用户同意后，录音将开启。乘客用户在下单时有其他同行人员的，下单乘客用户需告知同行人员或实际乘车人可能被采集录音的情况，在得到同行人同意后再进行下单。
        </div>
      </div>

      <div class="section">
        <div class="section-title">三、录音起始时间</div>
        <div class="section-item">
          1、录音自嘀嗒顺风车车主或嘀嗒顺风车、出租车乘客任意一方开启录音功能时开始，至以上车主或乘客关闭录音功能时停止（具体以嘀嗒出行App显示的录音状态为准）。如果以上车主或乘客未关闭录音功能，录音功能将在订单结束时终止。<strong>若持续开启时间较长，为保护您的隐私，录音功能将在通过短信提示十五分钟后自动关闭，您仍可通过嘀嗒出行App【安全中心】-【行程录音保护】重新开启。</strong>如果车主或乘客有多个订单且已开启录音功能，则录音功能将在车主或乘客关闭录音功能或最后一个订单结束时终止。
        </div>
        <div class="section-item">
          2、如您已授权开启录音权限，后续行程开启后录音将默认开启。
        </div>
        <div class="section-item">
          3、嘀嗒出行其他上线录音功能的服务的录音起始时间以嘀嗒出行平台另行告知为准。
        </div>
      </div>

      <div class="section">
        <div class="section-title">
          四、为保障用户的隐私，录音将实时上传至嘀嗒出行服务器，用户无法自行下载、调取或播放录音。
        </div>
      </div>

      <div class="section">
        <div class="section-title">
          五、录音信息将用于以下明确列明的使用场景：
        </div>
        <div class="section-subitem">
          ① 在征得乘客同意的情况下，作为平台处理用户纠纷的依据。
        </div>
        <div class="section-subitem">
          ② 为维护用户人身安全等重大合法权益，或情况紧急又很难得到用户同意的。
        </div>
        <div class="section-subitem">
          ③ 用于抽查检验用户是否存在违反平台用户规则的行为。
        </div>
        <div class="section-subitem">
          ④ 用于系统分析，设计、开发、应用保护用户安全的辅助工具或产品。
        </div>
      </div>

      <div class="section">
        <div class="section-title">
          六、嘀嗒出行平台将严格保护用户个人信息安全，除以下情况外，我们不会向其他人共享您的录音信息：
        </div>
        <div class="section-subitem">① 相关机关依据法定程序调取。</div>
        <div class="section-subitem">② 用户持法律文件依法调取。</div>
      </div>

      <div class="section">
        <div class="section-title">
          七、录音保存期限为7日。如遇差评、投诉、尚未处理完毕的纠纷等，平台将适当延长录音保存期限。
        </div>
      </div>

      <div class="section">
        <div class="section-title">
          八、用户使用的手机等硬件设备故障、网络状态不稳定、App版本过旧以及不可抗力等因素均可能导致录音失败，您对此表示理解，如遇此类问题，嘀嗒出行平台不需承担责任。
        </div>
      </div>

      <div class="section">
        <div class="section-title">
          九、嘀嗒出行平台将严格按照本协议约定收集使用用户录音信息。本协议对相关内容未作明确约定的，以嘀嗒出行平台《个人信息保护及隐私政策》约定为准。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Env from '@common/libs/util.env.js'
import { compareVersion } from '@common/libs/util.env.js'
export default {
  name: 'App',
  data() {
    return {
      is_new: 4,
      newClass: Env.inApplication && compareVersion(Env.curAppVersion, '10.0.0') >= 0
    }
  },
  mounted() {
    // 版本大于8.10.5 使用新版录音文件
    if (Env.inApplication && compareVersion(Env.curAppVersion, '8.10.5') >= 0) {
      this.is_new = 1
    } else {
      this.is_new = 2
    }
  }
}
</script>
<style scoped>
.newdiv102 {
  padding-top: 1.1rem;
}
</style>
